import request from "@/utils/request";

export function getSocialNetworks(with_accounts = 0, with_scores = 0) {
    return request({
        url: `/social_networks`,
        method: "get",
        params: {
            with_accounts,
            with_scores
        }
    });
}

export function showSocialNetwork(slug) {
    return request({
        url: `/social_networks/${slug}`,
        method: "get"
    });
}

export function getProductsByType(path) {
    return request({
        url: `/products`,
        method: "post",
        data: {
            path: path,
        }
    });
}
